import { forwardRef } from "react"
import { Draft } from "immer"
import { useUpdateEffect } from "react-use"
import { useImmerReducer } from "use-immer"
import { createContext } from "../utils"
import { MultiSelectAction, MultiSelectState, RootContextType } from "./types"
import { Container } from "./styles/ContainerStyle"

const [Provider, useMultiSelect] = createContext<RootContextType>(`MultiSelect`)

type RootOwnProps = Readonly<{
  onChange?: (tags: ReadonlyArray<string>) => void
  defaultValues?: ReadonlyArray<string>
}>

export type RootProps = RootOwnProps & Omit<React.ComponentPropsWithRef<typeof Container>, "onChange">
const Root: React.FC<RootProps> = forwardRef(
  ({ onChange, defaultValues, ...containerProps }: RootProps, forwardedRef) => {
    const [state, dispatch] = useImmerReducer<MultiSelectState, MultiSelectAction>(reducer, {
      tags: defaultValues ?? [],
    })

    useUpdateEffect(() => {
      onChange?.(state.tags)
    }, [state.tags.length])

    return (
      <Provider state={state} dispatch={dispatch}>
        <Container ref={forwardedRef} {...containerProps} />
      </Provider>
    )
  }
)

function reducer(state: Draft<MultiSelectState>, action: MultiSelectAction): MultiSelectState {
  switch (action.type) {
    case `setTags`:
      return {
        tags: action.tags,
      }
    case `addTag`:
      return {
        tags: [...state.tags, action.tag],
      }
    case `removeTag`:
      return {
        tags: [...state.tags].filter((tag) => tag !== action.tag),
      }
    default:
      throw new Error(`No action of type ${action} exists`)
  }
}

Root.displayName = `MultiSelectRoot`

export { Root, useMultiSelect }
